import { render, staticRenderFns } from "./d-amazon-store-selection.vue?vue&type=template&id=3e72dcca&scoped=true&"
import script from "./d-amazon-store-selection.vue?vue&type=script&lang=js&"
export * from "./d-amazon-store-selection.vue?vue&type=script&lang=js&"
import style0 from "./d-amazon-store-selection.vue?vue&type=style&index=0&id=3e72dcca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72dcca",
  null
  
)

export default component.exports